import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledItemPageRoot = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	min-height: 0;
	overflow: hidden;
`;

const StyledTopContainer = styled.div`
	display: grid;
	grid-template-columns: 30% 40% 30%;
	align-items: center;
	flex-shrink: 0;
	height: 80px;
	padding: 0 20px;
	border-bottom: 1px solid rgba(217, 217, 217, 0.1);
`;

const StyledItemPrice = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
`;

const StyledRightContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 20px;
`;

const StyledBackButtonContent = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	img {
		width: 6px;
		height: 10px;
	}
`;

const StyledLeftContainer = styled.div`
	display: flex;
	flex-direction: column;
	min-height: 0;
	height: 100%;
	border-right: 1px solid rgba(255, 255, 255, 0.1);
`;

const StyledMainContainer = styled.div`
	display: grid;
	grid-template-columns: 390px 1fr;
	flex: 1;
	min-height: 0;
`;

const StyledImageContainer = styled.div`
	position: relative;
	width: 100%;
	height: 260px;

	img {
		height: 100%;
		object-fit: cover;
		user-select: none;
		pointer-events: none;
	}
`;

const StyledPlayersBadge = styled.div`
	position: absolute;
	top: 20px;
	left: 20px;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 4px;
	height: 20px;
	background-color: #2d70da;
	border-radius: 6px;
	padding: 0 5px;

	${Text} {
		font-weight: 700;
		font-size: 12px;
		color: #ffffff;
	}

	img {
		width: 10px;
		height: 10px;
		user-select: none;
		pointer-events: none;
	}
`;

const StyledTimerBadge = styled.div`
	position: absolute;
	top: 20px;
	right: 20px;
	gap: 4px;
	height: 20px;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #ffffff;
	border-radius: 6px;
	padding: 0 5px;

	${Text} {
		font-weight: 700;
		font-size: 12px;
		color: #000000;

		span {
			font-weight: 500;
			opacity: 0.5;
		}
	}
`;

const StyledInfoContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr auto;
	gap: 20px;
	padding: 20px;

	${Text} {
		color: #ffffff;
		font-size: 14px;
	}
`;

const StyledInfoTitle = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	grid-column: span 2;

	${Text} {
		font-size: 14px;
		color: #ffffff;
		opacity: 0.75;
	}

	img {
		width: 14px;
		height: 14px;
		user-select: none;
		pointer-events: none;
		opacity: 0.75;
	}
`;

const StyledInfoValue = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 6px;

	img {
		width: 14px;
		height: 14px;
		user-select: none;
		pointer-events: none;
		opacity: 0.5;
	}
`;

const StyledBottomInfoContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 50px;
	margin-top: auto;
	padding: 0 20px;
	border-top: 1px solid rgba(255, 255, 255, 0.1);

	${Text} {
		font-size: 14px;
		color: #ffffff;
		opacity: 0.25;
	}
`;

const StyledFeedWrapper = styled.div`
	padding: 20px;
`;

const StyledFeedContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
	background-color: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 5px;
	height: 100%;
	padding: 20px;
	overflow: hidden;
`;

const StyledFeedHead = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const StyledFeedList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
`;

const StyledFeedButtonsContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 10px;
	min-width: 470px;
`;

const StyledFeedButtonContent = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 6px;
`;

const StyledPlayerBid = styled.div`
	display: flex;
	flex-direction: column;
	gap: 6px;
	padding: 10px;
	width: fit-content;
	background-color: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 5px;

	${Text} {
		color: #ffffff;
		font-size: 14px;
	}
`;

const StyledMyBid = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	gap: 6px;
	padding: 10px;
	width: fit-content;
	background-color: #2d70da;
	border-radius: 5px;
	align-self: flex-end;

	${Text} {
		color: #ffffff;
		font-size: 14px;
	}
`;

const StyledLongAuction = styled.div`
	display: flex;
	align-items: center;
	gap: 6px;
	padding: 0 10px;
	height: 30px;
	width: fit-content;
	background-color: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 5px;

	${Text} {
		color: #ffffff;
		font-size: 14px;
	}
`;

export {
	StyledBackButtonContent,
	StyledBottomInfoContainer,
	StyledFeedButtonContent,
	StyledFeedButtonsContainer,
	StyledFeedContainer,
	StyledFeedHead,
	StyledFeedList,
	StyledFeedWrapper,
	StyledImageContainer,
	StyledInfoContainer,
	StyledInfoTitle,
	StyledInfoValue,
	StyledItemPageRoot,
	StyledItemPrice,
	StyledLeftContainer,
	StyledLongAuction,
	StyledMainContainer,
	StyledMyBid,
	StyledPlayerBid,
	StyledPlayersBadge,
	StyledRightContainer,
	StyledTimerBadge,
	StyledTopContainer,
};
